/**
 * Local images — Unsplash & Pexels (free for commercial use).
 * See public/images/parts/ATTRIBUTION.txt
 */
export const PART_IMAGES = {
  engine: '/images/parts/engine.jpg',
  transmission: '/images/parts/transmission.jpg',
  alternator: '/images/parts/alternator.jpg',
  starter: '/images/parts/starter.jpg',
  acCompressor: '/images/parts/ac-compressor.jpg',
  brakes: '/images/parts/brakes.jpg',
  radiator: '/images/parts/radiator.jpg',
  fuelSystem: '/images/parts/fuel-system.jpg',
  workshop: '/images/parts/workshop.jpg',
  partsShelf: '/images/parts/parts-shelf.jpg',
};

export const CATEGORY_IMAGES = {
  Engines: PART_IMAGES.engine,
  Transmissions: PART_IMAGES.transmission,
  Alternators: PART_IMAGES.alternator,
  Starters: PART_IMAGES.starter,
  'AC Compressors': PART_IMAGES.acCompressor,
  'Brake Systems': PART_IMAGES.brakes,
  Radiators: PART_IMAGES.radiator,
  'Fuel Systems': PART_IMAGES.fuelSystem,
};

export const WHYUS_SHOWCASE = [
  { src: PART_IMAGES.engine, alt: 'Used engine', title: 'Engine — 3.5L V6', sub: '2019 Toyota Camry', badge: 'In Stock' },
  { src: PART_IMAGES.alternator, alt: 'Used alternator', title: 'Alternator', sub: '2020 Ford F-150', badge: 'Ships Today' },
  { src: PART_IMAGES.fuelSystem, alt: 'Used fuel system part', title: 'Fuel Pump Assembly', sub: '2018 Honda Accord', badge: 'Verified OEM' },
];

export const IMAGE_SECTION_ITEMS = [
  { src: PART_IMAGES.workshop, alt: 'Certified auto parts workshop', caption: 'Certified Workshop' },
  { src: PART_IMAGES.engine, alt: 'Used OEM engine', caption: 'OEM Engines' },
  { src: PART_IMAGES.transmission, alt: 'Used transmission assembly', caption: 'Transmissions' },
  { src: PART_IMAGES.brakes, alt: 'Used brake system components', caption: 'Brake Systems' },
  { src: PART_IMAGES.alternator, alt: 'Used alternator', caption: 'Electrical Parts' },
  { src: PART_IMAGES.partsShelf, alt: 'Used parts inventory shelf', caption: '1M+ Parts In Stock' },
  { src: PART_IMAGES.radiator, alt: 'Used radiator', caption: 'Cooling Systems' },
  { src: PART_IMAGES.starter, alt: 'Used starter motor', caption: 'Starters & More' },
];
